/* Infobulle de première visite sur le globe 🌍 (comme le site) : une fois (localStorage jp_carte_bulle), fermée au clic, après 15 s ou à l'ouverture de la carte.
   localStorage lève en navigation privée stricte : erreur = déjà vue, l'en-tête n'en souffre pas. */
(() => {
  const bulle = document.querySelector('[data-map-bubble]');
  if (!bulle) return;
  const vue = () => { try { return localStorage.getItem('jp_carte_bulle') === '1'; } catch (e) { return true; } };
  const fermer = () => { try { localStorage.setItem('jp_carte_bulle', '1'); } catch (e) {} bulle.hidden = true; };
  if (vue()) return;
  if (location.pathname === '/pages/carte') return fermer();
  bulle.hidden = false;
  setTimeout(fermer, 15000);
  bulle.querySelector('[data-map-bubble-ok]').addEventListener('click', fermer);
  document.querySelector('[data-map-link]').addEventListener('click', fermer);
})();
